// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8701dc61","455":"588bb1b4","690":"52473f36","853":"cc5ed314","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};